<!--
 * @Descripttion: 
 * @Author: luoyang
 * @Date: 2021-09-14 17:59:09
 * @LastEditors: luoyang
 * @LastEditTime: 2021-09-26 14:56:48
-->
<template>
  <!-- how we work轮播 -->
  <div class="work">
    <div class="title">HOW WE WORK</div>
    <div class="content flex-start-center">
      <div class="left swiper-container swiper-container-work-left">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in workBannerListLeft" :key="index" :class="item.title">
            <div class="slide-title">{{item.title}}</div>
            <div class="slide-content">{{item.content}}</div>
          </div>

        </div>
        <!-- 如果需要分页器 -->
        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-btn-wrap">
            <a class="button swiper-button-prev" href="#none" role="button"></a>
            <div class="swiper-pagination swiper-pagination-work"><span class="crrent-page"></span>/<span class="total-page"></span></div>
            <a class="button swiper-button-next" href="#none" role="button"></a>
          </div> -->

      </div>

      <!--  <div class="swiper-btn-wrap">
        <a class="button swiper-button-prev" href="#none" role="button" aria-label="Previous slide" aria-disabled="false"></a>
        <div class="swiper-pagination swiper-pagination-work"></div>
        <a class="button swiper-button-next" href="#none" role="button" aria-label="Next slide" aria-disabled="false"></a>
      </div> -->

      <div class="right swiper-container swiper-container-work-right">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in workBannerListRight" :key="index" :class="item"></div>
        </div>
        <!-- 如果需要分页器 -->
        <!-- <div class="swiper-pagination swiper-pagination-work"></div> -->

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div> -->

        <!-- 如果需要滚动条 -->
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>
      <div class="swiper-btn-wrap">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination swiper-pagination-work"></div>
        <div class="swiper-button-next"></div>
      </div>

    </div>

    <div class="fill" :style="{ '--scale': getHeight(160) }"></div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            scale: ((window.innerHeight - 548) * 100) / window.innerHeight / 532,
            innerHeight: window.innerHeight + "px",
            workBannerListLeft: [
                { title: "愿景", content: "成长为物联网场景应用的领导者" },
                {
                    title: "使命",
                    content:
                        "成就员工、赋能客户、回馈社会，为国家数字化经济建设尽绵薄之力。",
                },
                { title: "核心价值观", content: "创造价值,共享丰盛,持续创新" },
                // { title: "title4", content: "content4" },
            ],
            // workBannerListRight: ["banner1", "banner2", "banner3", "banner4"],
            workBannerListRight: ["banner1", "banner2", "banner3"],
        };
    },
    mounted() {
        console.log(window.innerHeight);
        console.log(((window.innerHeight - 548) * 100) / window.innerHeight) / 532;
        console.log(this.getHeight(160));
        // work轮播左
        new Swiper(".swiper-container-work-left", {
            direction: "horizontal", //水平(horizontal)或垂直(vertical)。
            loop: true, //loop模式：会在原本slide前后复制若干个slide(默认一个)并在合适的时候切换，让Swiper看起来是循环的。
            // 如果需要分页器
            pagination: ".swiper-pagination-work",
            paginationType: "fraction",
            paginationClickable: true,

            // 如果需要前进后退按钮
            nextButton: ".swiper-button-next",
            prevButton: ".swiper-button-prev",

            // 如果需要滚动条
            // scrollbar: ".swiper-scrollbar",
        });
        // work轮播右
        new Swiper(".swiper-container-work-right", {
            direction: "horizontal", //水平(horizontal)或垂直(vertical)。
            loop: true, //loop模式：会在原本slide前后复制若干个slide(默认一个)并在合适的时候切换，让Swiper看起来是循环的。
            // 如果需要分页器
            // pagination: ".swiper-pagination-work",
            // paginationType: "fraction",
            // paginationClickable: true,

            slidesPerView: "auto",
            spaceBetween: 80,

            // 如果需要前进后退按钮
            nextButton: ".swiper-button-next",
            prevButton: ".swiper-button-prev",

            // 如果需要滚动条
            // scrollbar: ".swiper-scrollbar",
        });
    },
    methods: {
        getHeight(height) {
            height * this.scale + "vh";
        },
    },
};
</script>

<style lang="scss" scoped>
$base-color: #000;
.work {
  height: 100vh;
  width: 100vw;
.title {
// height: 372px;
  height: 34.444vh;
  box-sizing: border-box;
  padding-top: 8vh;
  width: 100vw;
  text-align: center;
  font-size: 68px;
  font-family: HYDaHeiJ;
  color: $base-color;
  font-weight: 600;
}
.content {
  width: calc(100vw - 180px);
  padding-left: 180px;
// padding: calc((100vh - 856px) / 2) 0px (100vh - 856px)/2 180px;
// height: calc(100vh - 372px);
  position: relative;
  height: 548px;
.swiper-container-work-left {
  width: 440px;
  margin-right: 120px;
  height: 548px;
  overflow: hidden;
.swiper-slide {
  width: 440px !important;
.slide-title {
  font-size: 56px;
  font-weight: 500;
  color: $base-color;
}
.slide-content {
  font-size: 20px;
  color: $base-color;
  margin-top: 46px;
  line-height: 30px;
}
}
}
.swiper-container-work-right {
  width: 1180px;
  height: 548px;
  overflow: hidden;
.swiper-slide {
  width: 860px;
&.banner1 {
   background: url("../../../assets/imgs/about/vision_pic.jpg") no-repeat;
   background-size: cover;
 }
&.banner2 {
   background: url("../../../assets/imgs/about/pic2.jpg") no-repeat;
   background-size: cover;
 }
&.banner3 {
   background: url("../../../assets/imgs/about/values_pic.jpg") no-repeat;
   background-size: cover;
 }
&.banner4 {
   background: url("../../../assets/imgs/about/vision_pic.jpg") no-repeat;
   background-size: cover;
 }
}
}
}
.swiper-btn-wrap {
  position: absolute;
  bottom: -10px;
  left: 180px;
  width: 175px;
  height: 50px;
.swiper-pagination {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  line-height: 0.8;
  font-size: 18px;
  color: #888;
  font-family: "Roboto-Regular";
  letter-spacing: 0;
  z-index: 1;
  bottom: 10px;
  width: 100%;
}
.swiper-button-next,
.swiper-button-prev {
  width: 50px;
  height: 50px;
  box-sizing: border-box;
  background-size: 15px 26px;
  background-color: #ffffff;
  border: 1px solid #dcdcde;
  border-radius: 50%;
}
.swiper-button-next {
  background: url("../../../assets/imgs/home/icon_right.png") no-repeat
  center;
  background-size: 7.5px, 13px;
&:hover {
   background-color: #333 !important;
   background: url("../../../assets/imgs/home/icon_right_hover.png")
   no-repeat center;
   background-size: 7.5px, 13px;
 }
}
.swiper-button-prev {
  background: url("../../../assets/imgs/home/icon_left.png") no-repeat
  center;
  background-size: 7.5px, 13px;
&:hover {
   background-color: #333 !important;
   background: url("../../../assets/imgs/home/icon_left_hover.png")
   no-repeat center;
   background-size: 7.5px, 13px;
 }
}
}
.fill {
// height:160px;
  height: 14.815vh;
// height: var(--scale);
}
}
</style>